import styled from "styled-components";




export const UpdatePaymentMethodContainer = styled.div`
  padding: 0 20px;
  padding-top: 35px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(100% - 230px);
`;



export const UpdatePaymentMethodHeader = styled.div`
  display: flex;
  justify-content: center;
`;
export const UpdatePaymentMethodTitle = styled.div`
    color: #002E5C;
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
`;
export const UpdatePaymentMethodContent = styled.div`
  margin-top: 40px;
  flex: 1
`;

export const UpdatePaymentMethodFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 20px;
`

export const UpdatePaymentMethodSelected = styled.div`
    color: #4D5565;
    font-size: 16px;
    line-height: 32px;
`

export const UpdatePaymentMethodActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-bottom: 20px;
`